import React from "react";

export function findComponentByType(children, displayName) {
    if (!children) return null;

    // Handle fragments - React.Fragment has type === React.Fragment
    const isFragment = (child) => {
        if (!child || !child.type) return false;
        // React.Fragment can be a symbol or the Fragment component
        return child.type === React.Fragment ||
            (typeof child.type === 'symbol' && child.type.toString().includes('Fragment')) ||
            (child.type.$$typeof && child.type.$$typeof.toString().includes('Fragment'));
    };

    const results = [];

    React.Children.forEach(children, (child) => {
        if (!child) return;

        // Debug logging - DISABLED for production
        // if (displayName === 'BodyFooter' || displayName === 'Header') {
        //     console.warn(`[findComponentByType] Looking for "${displayName}":`, {
        //         childType: typeof child?.type,
        //         childTypeName: child?.type?.name,
        //         childTypeDisplayName: child?.type?.displayName,
        //         isValidElement: React.isValidElement(child)
        //     });
        // }

        // Check if this child matches - check displayName, name, _modalComponentType, and common patterns
        const childDisplayName = child.type?.displayName;
        const childName = child.type?.name;
        const childModalType = child.type?._modalComponentType;
        // Check all possible ways to identify the component
        const isMatch = childDisplayName === displayName || 
                       childName === displayName ||
                       childModalType === displayName ||
                       (displayName === 'BodyFooter' && (childName === 'ModalBodyFooter' || childDisplayName === 'ModalBodyFooter'));
        if (isMatch) {
            results.push(child);
            return;
        }

        // If it's a fragment, traverse into its children
        if (isFragment(child)) {
            const fragmentChildren = child.props?.children;
            if (fragmentChildren) {
                const found = findComponentByType(fragmentChildren, displayName);
                if (found) {
                    // found might be an array or a single element
                    if (Array.isArray(found)) {
                        results.push(...found.filter(f => f !== null));
                    } else if (found !== null) {
                        results.push(found);
                    }
                }
            }
            return;
        }

        // Otherwise, traverse into props.children
        const grandChildren = child.props?.children;
        if (grandChildren) {
            const found = findComponentByType(grandChildren, displayName);
            if (found) {
                // found might be an array or a single element
                if (Array.isArray(found)) {
                    results.push(...found.filter(f => f !== null));
                } else if (found !== null) {
                    results.push(found);
                }
            }
        }
    });

    return results.length > 0 ? results : null;
}

export function doesComponentContainContents(element, contents) {
    if (!element) return false;
    else if (typeof (element) === 'string' && element.includes(contents)) return true;
    else {
        const grandChildren = element.props?.children;
        if (typeof (grandChildren) === 'string') return grandChildren.includes(contents);
        else if (grandChildren) return grandChildren.some(gc => doesComponentContainContents(gc, contents));
        else return false;
    }
}